export default "__VITE_ASSET__NJhMa8DV__"